import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { AirlineService } from 'src/app/api/flight/airline.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-airlines-form',
  templateUrl: './airlines-form.component.html',
  styleUrls: ['./airlines-form.component.css']
})
export class AirlinesFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // url icon
  imageUrl: any = null;
  fileUrlImage: any = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private airlineService: AirlineService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      code_iata: [null],
      url_image: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;     
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.airlineService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          description: item_.description,
          code_iata: item_.code_iata,
          url_image: item_.url_image
        });
      }
    });
  }


  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      formData.append('item', JSON.stringify(data));
      formData.append('url_image', this.fileUrlImage);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.airlineService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.airlineService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/pasajes/aerolinea/lista']);
  }
}
